import { ImageLink } from "./image-link";

export const ImageLinkList = () => {
  return (
    <div className="flex flex-col items-center gap-8 sm:flex-row sm:items-stretch sm:justify-evenly sm:gap-6">
      <ImageLink src="/assets/brooke.png" title="Meet the Clinical Team" to="/clinical-team" />

      <div className="hidden border-l border-line sm:block" />

      <ImageLink
        src="/assets/images/product-research-and-testing.jpg"
        title="Product Research & Testing"
        to="/product-research-and-testing"
      />
    </div>
  );
};
